'use client';

import { Fragment } from 'react';

import { useTranslations } from 'next-intl';

import { useVerification } from '@/contexts/VerificationContext/useVerification';

import { Tabs } from '@/components/Tabs';

import styles from '@/contexts/VerificationContext/VerificationModal/AuthVerification/AuthVerification.module.scss';
import { AuthVerificationHeader } from '@/contexts/VerificationContext/VerificationModal/AuthVerification/AuthVerificationHeader';
import { LoginWithPhone } from '@/contexts/VerificationContext/VerificationModal/AuthVerification/LoginWithPhone';
import { SmsForm } from '@/contexts/VerificationContext/VerificationModal/AuthVerification/LoginWithPhone/SmsForm';
import { LoginWithUsername } from '@/contexts/VerificationContext/VerificationModal/AuthVerification/LoginWithUsername';
import { SocialLoginPanel } from '@/contexts/VerificationContext/VerificationModal/AuthVerification/SocialLoginPanel';

export const AuthVerification = () => {
  const t = useTranslations('verification');

  const { isQRCodeVerification, hasOtp } = useVerification();

  return (
    <div className={styles.authVerificationWrapper}>
      {!isQRCodeVerification ? (
        <Fragment>
          <header>
            <AuthVerificationHeader />
          </header>
          {!hasOtp ? (
            <Tabs
              variant="secondary"
              className={styles.authVerificationTabs}
              switchersClassName={styles.authVerificationTabsSwitchers}
            >
              <Tabs.Switchers>
                <Tabs.Switcher>{t('signInUsingYourPhone')}</Tabs.Switcher>
                <Tabs.Switcher>{t('signInUsingYourLogin')}</Tabs.Switcher>
              </Tabs.Switchers>
              <Tabs.Panels>
                <Tabs.Panel>
                  <LoginWithPhone />
                </Tabs.Panel>
                <Tabs.Panel>
                  <LoginWithUsername />
                </Tabs.Panel>
              </Tabs.Panels>
            </Tabs>
          ) : (
            <SmsForm />
          )}
          <footer>
            <SocialLoginPanel />
          </footer>
        </Fragment>
      ) : (
        <>QR</>
      )}
    </div>
  );
};
